import(/* webpackMode: "eager" */ "/codebuild/output/src88813650/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/global-error.tsx");
